<div class="space-y-4 overflow-visible">
    <!-- Toolbar: search · status · count · tenant filter · add -->
    <div class="flex flex-col lg:flex-row lg:items-center gap-3">
        <div class="relative flex-1 min-w-0">
            <svg class="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
            <input type="text" [(ngModel)]="searchQuery" (ngModelChange)="filterEmployees()" placeholder="Search team members…"
                class="w-full pl-9 pr-3 py-2 text-sm bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent transition-all placeholder-gray-400">
        </div>

        <div class="flex items-center gap-2 shrink-0 flex-wrap">
            @if(statusFilter === 'ACTIVE' && archivedCount > 0) {
                <span class="inline-flex items-center gap-1.5 text-xs bg-amber-50 text-amber-700 px-2.5 py-1.5 rounded-lg font-medium border border-amber-100 whitespace-nowrap">
                    <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"/>
                    </svg>
                    {{ archivedCount }} archived hidden
                </span>
            }
            @if(selectedTenantId || statusFilter !== 'ACTIVE' || searchQuery) {
                <button (click)="selectedTenantId = ''; statusFilter = 'ACTIVE'; searchQuery = ''; filterEmployees()"
                        class="inline-flex items-center gap-1 text-xs text-gray-500 hover:text-gray-700 cursor-pointer whitespace-nowrap">
                    <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                    </svg>
                    Clear filters
                </button>
            }

            <span class="text-xs font-medium text-gray-400 whitespace-nowrap">{{ filteredEmployees.length }} member{{ filteredEmployees.length !== 1 ? 's' : '' }}</span>

            <div class="relative">
                <select [(ngModel)]="statusFilter" (change)="filterEmployees()"
                    class="appearance-none pl-3 pr-8 py-2 rounded-lg text-sm font-medium border cursor-pointer transition-all focus:outline-none focus:ring-2 focus:ring-blue-400"
                    [class]="statusFilter !== 'ACTIVE' ? 'bg-amber-50 border-amber-300 text-amber-700' : 'bg-white border-gray-200 text-gray-600 hover:border-gray-300'">
                    <option value="ACTIVE">Active</option>
                    <option value="ARCHIVED">Archived</option>
                    <option value="ALL">All</option>
                </select>
                <svg class="absolute right-2.5 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-400 pointer-events-none" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M19 9l-7 7-7-7" /></svg>
            </div>

            <div class="relative">
                <select [(ngModel)]="selectedTenantId" (change)="filterEmployees()"
                    class="appearance-none pl-3 pr-8 py-2 rounded-lg text-sm font-medium border cursor-pointer transition-all focus:outline-none focus:ring-2 focus:ring-blue-400"
                    [class]="selectedTenantId ? 'bg-blue-50 border-blue-300 text-blue-700' : 'bg-white border-gray-200 text-gray-600 hover:border-gray-300'">
                    <option value="">All tenants</option>
                    @for(tenant of tenants; track tenant.id) { <option [value]="tenant.id">{{ tenant.name }}</option> }
                </select>
                <svg class="absolute right-2.5 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-400 pointer-events-none" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M19 9l-7 7-7-7" /></svg>
            </div>

            <button (click)="showAddModal = true"
                class="inline-flex items-center gap-1.5 px-4 py-2 bg-blue-600 text-white text-sm font-semibold rounded-lg hover:bg-blue-700 transition-colors shadow-sm cursor-pointer whitespace-nowrap">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" /></svg>
                Add Employee
            </button>
        </div>
    </div>

    @if(loading) {
        <div class="flex justify-center items-center py-16">
            <div class="w-8 h-8 rounded-full border-4 border-blue-100 border-t-blue-600 animate-spin mr-3"></div>
            <span class="text-gray-500">Loading employees...</span>
        </div>
    } @else {
        <!-- Employee Table -->
        <div class="border border-gray-200 rounded-xl overflow-visible">
            <table class="w-full">
                <thead>
                    <tr class="bg-gray-50 border-b border-gray-200 rounded-t-xl">
                        <th class="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wide first:rounded-tl-xl">Employee</th>
                        <th class="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wide">Tenant</th>
                        <th class="px-4 py-3 text-center text-xs font-semibold text-gray-500 uppercase tracking-wide">Role</th>
                        <th class="px-4 py-3 text-right text-xs font-semibold text-gray-500 uppercase tracking-wide w-20 last:rounded-tr-xl"></th>
                    </tr>
                </thead>
                <tbody class="divide-y divide-gray-100">
                    @for(emp of filteredEmployees; track emp.id) {
                        <tr class="hover:bg-blue-50/50 transition-colors group"
                            [class.bg-gray-50]="emp.isArchived">
                            <!-- Employee Info -->
                            <td class="px-4 py-3">
                                <div class="flex items-center gap-3">
                                    <div class="w-10 h-10 rounded-xl flex items-center justify-center text-white text-sm font-bold shadow-sm flex-shrink-0"
                                         [ngClass]="emp.isArchived
                                            ? 'bg-gradient-to-br from-gray-400 to-gray-500'
                                            : 'bg-gradient-to-br from-blue-500 to-indigo-600'">
                                        {{ (emp.firstName || '?').charAt(0) }}{{ (emp.name || '?').charAt(0) }}
                                    </div>
                                    <div class="min-w-0">
                                        <div class="font-semibold truncate flex items-center gap-2"
                                             [ngClass]="emp.isArchived ? 'text-gray-500' : 'text-gray-900'">
                                            <span class="truncate">{{ emp.firstName }} {{ emp.name }}</span>
                                            @if(emp.isArchived) {
                                                <span class="inline-flex items-center px-2 py-0.5 rounded-md text-[10px] font-semibold uppercase tracking-wide bg-amber-100 text-amber-700 border border-amber-200 flex-shrink-0">
                                                    Archived
                                                </span>
                                            }
                                        </div>
                                        <div class="text-sm text-gray-500 truncate">{{ emp.email }}</div>
                                        @if(emp.phone) {
                                            <div class="text-xs text-gray-400 flex items-center gap-1 mt-0.5">
                                                <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
                                                </svg>
                                                {{ emp.phone }}
                                            </div>
                                        }
                                        @if(emp.isArchived && emp.archivedAt) {
                                            <div class="text-xs text-amber-600 mt-0.5">
                                                Archived on {{ emp.archivedAt | date:'mediumDate' }}
                                            </div>
                                        }
                                    </div>
                                </div>
                            </td>

                            <!-- Tenant Badge -->
                            <td class="px-4 py-3">
                                <span class="inline-flex items-center px-2.5 py-1 rounded-lg text-xs font-medium bg-gray-100 text-gray-700">
                                    {{ getEmployeeTenantNames(emp) }}
                                </span>
                            </td>

                            <!-- Role Selector -->
                            <td class="px-4 py-3 text-center">
                                <div class="inline-flex items-center">
                                    <select [ngModel]="emp.role" (change)="updateRole(emp, $event)"
                                            [disabled]="!!emp.isArchived"
                                            class="appearance-none px-3 py-1.5 rounded-lg text-xs font-semibold
                                                   border transition-all outline-none text-center
                                                   focus:ring-2 focus:ring-offset-1
                                                   disabled:opacity-60 disabled:cursor-not-allowed
                                                   enabled:cursor-pointer"
                                            [ngClass]="{
                                                'bg-purple-100 text-purple-700 border-purple-200 focus:ring-purple-400': emp.role === 'SUPERADMIN',
                                                'bg-blue-100 text-blue-700 border-blue-200 focus:ring-blue-400': emp.role === 'ADMIN',
                                                'bg-gray-100 text-gray-700 border-gray-200 focus:ring-gray-400': emp.role === 'EMPLOYEE'
                                            }">
                                        <option value="SUPERADMIN">Super Admin</option>
                                        <option value="ADMIN">Admin</option>
                                        <option value="EMPLOYEE">Employee</option>
                                    </select>
                                </div>
                            </td>

                            <!-- Actions (overflow menu pattern) -->
                            <td class="px-4 py-3 text-right" style="overflow: visible;">
                                <div class="relative inline-block" #menuContainer>
                                    <button (click)="toggleMenu(emp.id); $event.stopPropagation()"
                                            class="p-2 rounded-lg text-gray-500 hover:text-gray-700 hover:bg-gray-100 bg-gray-50 border border-gray-200
                                                   transition-all cursor-pointer">
                                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 5v.01M12 12v.01M12 19v.01"/>
                                        </svg>
                                    </button>
                                    @if(openMenuId === emp.id) {
                                        <div class="fixed right-auto mt-1 w-44 bg-white rounded-lg shadow-xl border border-gray-200 py-1"
                                             style="z-index: 9999; position: absolute; right: 0;">
                                            <button (click)="openTenantModal(emp); $event.stopPropagation()"
                                                    class="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2 cursor-pointer">
                                                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
                                                </svg>
                                                Manage Tenants
                                            </button>
                                            @if(emp.isArchived) {
                                                <button (click)="confirmArchive(emp); $event.stopPropagation()"
                                                        class="w-full px-4 py-2 text-left text-sm text-green-700 hover:bg-green-50 flex items-center gap-2 cursor-pointer">
                                                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
                                                    </svg>
                                                    Restore
                                                </button>
                                            } @else {
                                                <button (click)="confirmArchive(emp); $event.stopPropagation()"
                                                        class="w-full px-4 py-2 text-left text-sm text-amber-700 hover:bg-amber-50 flex items-center gap-2 cursor-pointer">
                                                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"/>
                                                    </svg>
                                                    Archive
                                                </button>
                                            }
                                            <button (click)="confirmDelete(emp.id); $event.stopPropagation()"
                                                    class="w-full px-4 py-2 text-left text-sm text-red-600 hover:bg-red-50 flex items-center gap-2 cursor-pointer">
                                                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                                                </svg>
                                                Delete
                                            </button>
                                        </div>
                                    }
                                </div>
                            </td>
                        </tr>
                    }
                </tbody>
            </table>

            @if(filteredEmployees.length === 0 && !loading) {
                <div class="py-16 text-center bg-gray-50">
                    <svg class="w-12 h-12 text-gray-300 mx-auto mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"/>
                    </svg>
                    <p class="text-gray-500 font-medium">
                        {{ statusFilter === 'ARCHIVED' ? 'No archived employees' : 'No employees found' }}
                    </p>
                    @if(searchQuery || selectedTenantId || statusFilter !== 'ALL') {
                        <p class="text-sm text-gray-400 mt-1">Try changing the search, status or tenant filter</p>
                    }
                </div>
            }
        </div>
    }
</div>

@if(showConfirmDelete) {
    <app-confirm-modal
        [message]="'Are you sure you want to delete this employee? This action cannot be undone.'"
        (close)="handleConfirmDelete($event)">
    </app-confirm-modal>
}

@if(showConfirmArchive) {
    <app-confirm-modal
        [message]="archiveConfirmMessage"
        (close)="handleConfirmArchive($event)">
    </app-confirm-modal>
}

@if(showTenantModal && employeeToEditTenants) {
    <div class="fixed inset-0 z-9999 flex items-center justify-center bg-black/40 backdrop-blur-sm p-4"
         (click)="closeTenantModal()">
        <div (click)="$event.stopPropagation()">
            <app-edit-employee-tenants
                [employee]="employeeToEditTenants"
                (close)="closeTenantModal()"
                (saved)="onTenantsSaved()">
            </app-edit-employee-tenants>
        </div>
    </div>
}

@if(showAddModal) {
    <div class="fixed inset-0 z-9999 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4"
         (click)="closeAddModal()">
        <div (click)="$event.stopPropagation()" class="w-full max-w-2xl">
            <app-add-employee (close)="closeAddModal()" />
        </div>
    </div>
}
